import { showError} from './swalHandler';

/**
 * Validates file size and shows error modal if file is too large
 * @param {File} file - The file to validate
 * @param {number} maxSizeInMB - Maximum file size in MB (default: 10MB)
 * @returns {Promise<boolean>} - Returns true if file is valid, false if too large
 */
export const validateFileSize = async (file, maxSizeInMB = 10) => {
  const maxSizeInBytes = maxSizeInMB * 1024 * 1024;
  
  if (file.size > maxSizeInBytes) {
    await showError('File Too Large', `File "${file.name}" is too large. Maximum size is ${maxSizeInMB}MB.`);
    return false;
  }
  
  return true;
};

/**
 * Validates multiple files and returns only the valid ones
 * @param {File[]} files - Array of files to validate
 * @param {number} maxSizeInMB - Maximum file size in MB (default: 10MB)
 * @returns {Promise<File[]>} - Returns array of valid files
 */
export const validateFiles = async (files, maxSizeInMB = 10) => {
  const validFiles = [];
  
  for (const file of files) {
    const isValid = await validateFileSize(file, maxSizeInMB);
    if (isValid) {
      validFiles.push(file);
    }
  }
  
  return validFiles;
};

/**
 * Validates file size and shows error modal if file is too large
 * @param {File} file - The file to validate
 * @param {number} maxSizeInMB - Maximum file size in MB (default: 10MB)
 * @returns {Promise<boolean>} - Returns true if file is valid, false if too large
 */
export const isValidImage = async (contentType) => {
  if (!contentType.startsWith('image/')) {
    await showError('Invalid File Type', `Only image files are allowed`);
    return false;
  }
  return true;
};
